import React from 'react'
import Style from './Button.module.scss'
const Button = (props) => {
  return (
    <button  className={Style[props.ClassBtn]} onClick={props.ClickHandler} disabled={props.disabledProps}>{props.Value}</button>
  )
}

export default Button